module.exports = __webpack_public_path__ + "img/caret-down.81412f4f.svg";